import axios from 'axios';

const MBTA_CALLOUT_API_URL = 'https://activities.marriott.com/api/services/bonvoy_app/products';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fetchMBTAcalloutData = async (requestData: any, specificDataToLook: string): Promise<any> => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let response: any[] = [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const errorData: any = {
    url: MBTA_CALLOUT_API_URL,
    show: true,
    status: '400',
    products: {},
  };

  console.log('requestData :::: ', requestData);

  if (!requestData?.code || !requestData?.currency || !requestData?.scope) {
    return errorData;
  } else {
    const uri = ` ${MBTA_CALLOUT_API_URL}?code=${requestData.code}&currency=${requestData.currency}&scope=${requestData.scope}&from=${requestData.checkin}&to=${requestData.checkout}`;
    console.log('MBTACalloutService API resolved URI', uri);
    try {
      const { data } = await axios.get(uri);
      const normalizedData = normalizeMBTAResponse(data);

      const finalData =
        specificDataToLook != null ? getSpecificMBTAData(specificDataToLook, normalizedData) : normalizedData;
      response = Array.isArray(finalData) ? finalData : finalData?.products ?? [];
      console.log('Response from fetchMBTAcalloutData', response);
    } catch (error) {
      response = [];
      console.error('fetchMBTAcalloutData Error Data Message', error);
    }

    return {
      response,
    };
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const normalizeMBTAResponse = (data: any): any[] => {
  if (Array.isArray(data)) {
    return data;
  }

  if (typeof data === 'string') {
    try {
      const parsedData = JSON.parse(data);
      return normalizeMBTAResponse(parsedData);
    } catch (error) {
      console.error('Unable to parse MBTA response payload', error);
      return [];
    }
  }

  if (Array.isArray(data?.data)) {
    return data.data;
  }

  if (Array.isArray(data?.results)) {
    return data.results;
  }

  if (Array.isArray(data?.products)) {
    return data.products;
  }

  return [];
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getSpecificMBTAData: any = (nameToLookFor: string, data: any) => {
  if (!Array.isArray(data)) {
    return null;
  }

  const normalizedLookup = nameToLookFor?.trim().toLowerCase();
  const hotel = data.find(
    (item: { name?: string }) => typeof item?.name === 'string' && item.name.trim().toLowerCase() === normalizedLookup
  );

  const fallbackHotel =
    hotel ??
    data.find((item: { name?: string; products?: unknown[] }) => {
      if (typeof item?.name !== 'string') {
        return false;
      }

      const normalizedName = item.name.trim().toLowerCase();
      return normalizedName.includes(normalizedLookup) || normalizedLookup.includes(normalizedName);
    });

  if (fallbackHotel) {
    return {
      ...fallbackHotel,
      products: Array.isArray(fallbackHotel.products) ? fallbackHotel.products : [],
    };
  }

  // Fallback: if API already returns product cards directly, use them.
  const looksLikeProductList = data.every(
    (item: { name?: string; description?: string; imageUrl?: string }) =>
      typeof item?.name === 'string' || typeof item?.description === 'string' || typeof item?.imageUrl === 'string'
  );
  if (looksLikeProductList) {
    return {
      products: data,
    };
  }

  return null;
};
